<template>
  <div>
        <v-data-table
            v-model="selected"
            :items="projectList"
            hide-default-footer
            :headers="headers"
            class="tb-contents new">
            <!-- :page.sync="page"
            :server-items-length="totalElements"
            :headers="headers"
            :must-sort="true"
            :items-per-page="itemsPerPage" 
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            @page-count="pageCount = $event" -->
            <template v-slot:item="{ item }">
              <tr :class="item.isState">
                <td class="division">
                  <router-link
                    :to="{ name: 'dashboard', params: { projectId: item.projectId } }"
                  >
                    <div class="subject ell-singleline" style="width: 589px;" :id="item.projectId">
                      {{ item.projectName }}
                    </div>
                  </router-link>
                  <!-- <div class="subject ell-singleline" style="width: 707px;">{{ item.projectName }}</div> -->
                </td>
                <td class="txtc"> 
                  <div type="button" :class="{
                            'ico-evaluate-good': item.status == 'GOOD',
                            'ico-evaluate-so': item.status == 'SO',
                            'ico-evaluate-delay': item.status == 'DELAY',
                            'ico-evaluate-exceeded': item.status == 'EXCEEDED',
                        }"><span class="hidden"></span></div>
                </td>
                <td class="txtc">
                  <button type="button" :class="{ active: item.favoriteYn == 1 ? 'active' : '' }"
                          class="ico-switch_favorites small"
                          @click="registProjectFavorites(item,item.projectId,item.favoriteYn,$event)">
                    즐겨찾기
                  </button>
                </td>
                <td class="feedback txtc">
                  <div class="list-team"> 
                    <button type="button" class="ico-txt_comment" @click="openCommentModal(item)">
                    <span>{{projectCommentCountList[item.projectId] != null ? 
                              projectCommentCountList[item.projectId] > 999 ? 999+'+' : projectCommentCountList[item.projectId] 
                              : 0}}</span>
                    </button> 
                  </div>
                </td>
                <td class="date txtc">
                  {{ $i18nUtil.getLanguage() !== 'ko' && item.regUserNameEn != null ? item.regUserNameEn : item.regUserName }}
                </td>
                <td class="date txtc">{{ $moment(item.lastProUpdDate).format("YYYY.MM.DD")}}
                  <span v-if="item.lastUpdStatus == 1" class="ico-new"></span></td>
              </tr>
            </template>

            <template slot="no-data">
              <div class="nodata-txt-noicon">
                <v-alert :value="true">
                  과제를 생성하여 체계적으로 업무를 관리해보세요.
                </v-alert>
                <button type="button" class="btn-primary-small black">과제 추가</button>
              </div>
            </template>

            <!-- <template v-slot:item="{ item }">
                <tr>
                    <td style="width:80px;text-align: center;">
                        <div :class="{
                            'ico-evaluate-good': item.status == 'GOOD',
                            'ico-evaluate-so': item.status == 'SO',
                            'ico-evaluate-delay': item.status == 'DELAY',
                            'ico-evaluate-exceeded': item.status == 'EXCEEDED',
                        }"></div>
                    </td>
                    <td style="width:auto"> 
                        <router-link
                            :to="{ name: 'dashboard', params: { projectId: item.projectId } }"
                            >
                            <div class="list-tit-m ell-multiline2 multi-ellipsis no-ellipsis" :class="item.projectId" style="font-size: 17px;"
                                @mouseover="mouseEvt(true, item, $event)"
                                @mouseleave="mouseEvt(false, item, $event)"
                            >
                                {{ item.projectName }}
                            </div>
                            <div class="tooltip-b tl small" style="z-index: 11; display: none;" :id="item.projectId+'_tooltip'"> 
                                {{ item.projectName }}
                            </div>

                        </router-link>
                    </td>
                    <td style="width:50px">
                        <div class="list-team fl"> 
                            <button type="button" class="ico-txt_comment" @click="openCommentModal(item)">
                            <span
                                :class="unReadComment.indexOf(item.projectId) != -1 ? 'ico-new' : ''">
                            </span>
                            </button> 
                        </div>
                    </td>
                    <td style="width:100px"> 
                            {{ $moment(item.lastProUpdDate).format("YYYY.MM.DD")}}
                    </td>
                    <td style="width:40px">
                        <button type="button" :class="{ active: item.favoriteYn == 1 ? 'active' : '' }"
                                class="ico-switch_favorites"
                                @click="registProjectFavorites(item,item.projectId,item.favoriteYn,$event)">
                            즐겨찾기
                        </button>
                    </td>
                </tr> 
            </template> -->
        </v-data-table>  
    </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import OkrListPopup from "@/components/cowork/general/project/modal/OkrListPopup";
import ProjectCommentModal from "../modal/ProjectCommentModal";
import ProjectComment from "@/components/cowork/general/project/modal/ProjectComment";
export default {
  components: {
    ProjectComment,  
  },
  props: {
    projectList: {
      type: Array,
      required: true,
    },
    loginUserId: String,
    unReadComment: Array,
    projectCommentCountList:Array
  },
  data() {
    return {
        selected: [],
        headers: [
          { text: this.$i18nUtil.trans("entity.projectList.projectName","과제명"), align: 'center', value: 'divideTxt', sortable: false, width: 'calc(100% - (118px*5)' },
          { text: this.$i18nUtil.trans("entity.projectList.status","진행단계"), value: 'ing-step', sortable: false, width: '118px' },
          { text: this.$i18nUtil.trans("entity.paper.filter.paperBookmar","즐겨찾기"), value: 'favorites', sortable: false, width: '118px'},
          { text: this.$i18nUtil.trans("entity.paper.filter.comment","의견/답변"), value: 'feedback', sortable: false, width: '118px'},
          { text: this.$i18nUtil.trans("entity.group.regUserId","생성자"), value: 'regUserName', sortable: false, width: '118px'},
          { text: this.$i18nUtil.trans("entity.projectList.lastUpdate","최종수정일"), value: 'update', sortable: false, width: '118px'},
        ],
      /* tenantId */
      tenantId: localStorage.getItem("tenantId"),
      enabled: true,
      testVal: 15,
      list: [],
      count: null,
      myProjectList: [],
      myProjectCount: null,
      tmpData: {
        commentMemberList: [],
      },
    };
  },
  methods: {
    /* REST-API */
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    /* 즐겨찾기 목록 갱신 */
    ...mapMutations("project", ["setProjectFavoriteList"]),
    /* 모달 팝업 */
    ...mapActions("modals", ["showModal"]),
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),

    /* 말줄임(...) 시, tooltip 적용 */
    mouseEvt(flag, element, event) {
      if(flag) {
        // 말줄임(...) css 적용 여부 체크 (boolean)
        let val = this.$tooltip.hasOverflownHeight(event.target);

        if(val) {
          document.getElementById(element.projectId+'_tooltip').style.display = 'block';
        }else{
          document.getElementById(element.projectId+'_tooltip').style.display = 'none';
        };
      }else{
        document.getElementById(element.projectId+'_tooltip').style.display = 'none';
      }
    },

    /* 즐겨찾기 등록(favoriteYn : 0이면 즐겨찾기 해제, 1이면 즐겨찾기 등록) */
    registProjectFavorites(project, projectId, favoriteYn, event) {
      let obj = this;
      let reqData = {
        method: "post",
        params: { projectId: projectId },
      };
      if (favoriteYn == 0) {
        /* 즐겨찾기 등록 */
        reqData.url = "/api/cogroup/project/registProjectFavorites";
      } else {
        /* 즐겨찾기 해제 */
        reqData.url = "/api/cogroup/project/deleteProjectFavorites";
      }
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          if (res.errorCode != null) {
            console.log(res.errorCode);
          } else {
            //event.target.classList.toggle("active");
            if(res.result !== null) {
              // res.result.forEach(item => {
              //   if(item.projectId === projectId) {
              //     project.favoriteYn = item.favoriteYn;
              //     event.target.classList.toggle("active");
              //   }
              // });
              // if(favoriteYn == 0) {
              //   project.favoriteYn = 1;
              // } else {
              //   project.favoriteYn = 0;
              // }
              obj.$emit("getMyProjectList");
            }
            //                    obj.getMyProjectList();
            //obj.setProjectFavoriteList(res.result);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    okrListPopup(element) {
      console.log(element);
      const modalInfo = {
        title: this.$i18nUtil.trans("entity.todo","할 일"),
        width: "800px",
        height: "617px",
        obj: this.$modal,
        projectId: element.projectId,
        projectName: element.projectName,
        publicYn: element.publicYn.toString(),
        startDate: element.startDate,
        endDate: element.endDate,
        component: OkrListPopup,
      };
      this.showModal(modalInfo);
    },
    openCommentModal(project) {
      const modalInfo = {
        title: this.$i18nUtil.trans("title.ProjectCommentModal.001","과제 의견"),
        name: "ProjectCommentModal",
        method: "post",
        width: "340px",
        obj: this.$modal,
        component: ProjectCommentModal,
        param: {
          projectId: project.projectId,
          groupId: project.groupId,
          userId: this.loginUserId,
          unReadComment: this.unReadComment,
        },
      };
      this.showModal(modalInfo);
    },
    /* 멤버  */
    getMemberlist(e, project) {
      let self = this;
      let reqData = {};
      reqData.req = {
        groupId: project.groupId,
      };
      let memberList = self.tmpData.commentMemberList;
      memberList.splice(0, self.tmpData.commentMemberList.length);
      reqData.url = "/api/cogroup/cogroupUser/getCogroupUserList";
      reqData.method = "post";
      self
        .COWORK_REST_ACTION(reqData)
        .then((res) => {
          console.log(res);
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            if (res.result && res.result.data) {
              res.result.data.forEach(item => {
                memberList.push(item);
              });
            }
            let inx = self.unReadComment.indexOf(project.projectId);
            if (inx != -1) {
              self.unReadComment.splice(inx, 1);
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    /* 말줄임 */
    multiElipsis(ellipsisLine, projectId) {
      let selecter = "multi-ellipsis " + projectId;
      var omle = document.getElementsByClassName(selecter);
      for(let item of omle){
        // console.log(projectId, item.scrollHeight);
        if (item.scrollHeight > 70) {
            item.classList.remove("no-ellipsis");
        } 
      } 
    },
  },
  mounted() {
    this.projectList.forEach(item => {
      this.multiElipsis(2, item.projectId)
    })
  }
};
</script>

<style scoped>
   
  /* .multi-ellipsis {
    overflow: hidden;
    position: relative;
    line-height: 1.44;
    text-align: justify;
    text-overflow: ellipsis;
    word-wrap: break-word;
    word-break: break-all;
  } */
  /* .multi-ellipsis:before,
  .multi-ellipsis:after {
    content: "...";
    line-height: 1;
    position: absolute;
    right: 0;
    top: 1.44em;
    -ms-wrap-flow: start;
  }
  .multi-ellipsis:after {
    background: currentColor !important;
    color: #fff !important;
    top: auto;
  }
  .multi-ellipsis.no-ellipsis::before,
  .multi-ellipsis.no-ellipsis::after {
    display: none;
  }
  @supports (-webkit-line-clamp: 2) {
    .multi-ellipsis {
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    .multi-ellipsis::before,
    .multi-ellipsis::after {
      content: normal;
    }
  } */
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/project/base/ProjectContentsList.vue